import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import themeManager from '../../utils/themeManager';

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(themeManager.getCurrentTheme());

  useEffect(() => {
    const handleThemeChange = (event) => setTheme(event.detail.theme);
    window.addEventListener('themeChanged', handleThemeChange);
    return () => window.removeEventListener('themeChanged', handleThemeChange);
  }, []);

  const pathMap = {
    sr: {
      '/': 'Početna',
      '/about': 'O nama',
      '/job': 'Poslovi',
      '/xiaomi': 'Xiaomi Store'
    },
    en: {
      '/': 'Home',
      '/about': 'About',
      '/job': 'Jobs',
      '/xiaomi': 'Xiaomi Store'
    }
  };

  const generateBreadcrumbs = () => {
    let currentPath = location?.pathname;

    // detekcija jezika
    const lang = currentPath.startsWith('/en') ? 'en' : 'sr';

    // ukloni /en iz path-a
    if (lang === 'en') {
      currentPath = currentPath.replace('/en', '');
    }

    const homePath = lang === 'en' ? '/en/homepage-hero-services' : '/homepage-hero-services';

    const breadcrumbs = [
      { label: pathMap[lang]['/homepage-hero-services'], path: homePath }
    ];

    if (currentPath !== '/homepage-hero-services') {
      const currentLabel = pathMap[lang]?.[currentPath] || 'Page';
      breadcrumbs.push({ label: currentLabel, path: location?.pathname });
    }

    return { breadcrumbs, isHome: currentPath === '/' || currentPath === '/homepage-hero-services' };
  };

  const { breadcrumbs, isHome } = generateBreadcrumbs();

  const handleNavigation = (path) => {
    navigate(path);
  };

  if (isHome) {
    return null;
  }

  const bgColor = theme === 'dark' ? 'bg-[#0F1115]' : 'bg-[#F3F4F6]';
  const textColor = theme === 'dark' ? 'text-white' : 'text-black';

  return (
    <nav className={`flex items-center space-x-2 py-4 text-sm font-body ${bgColor} ${textColor}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((crumb, index) => (
          <li key={crumb?.path} className="flex items-center">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-text-secondary mx-2" 
              />
            )}
            {index === breadcrumbs?.length - 1 ? (
              <span className="text-foreground font-medium flex items-center">
                {index === 0 && <Icon name="Home" size={16} className="mr-1" />}
                {crumb?.label}
              </span>
            ) : (
              <button
                onClick={() => handleNavigation(crumb?.path)}
                className="text-text-secondary hover:text-accent transition-colors duration-200 spring-animation flex items-center hover:underline"
              >
                {index === 0 && <Icon name="Home" size={16} className="mr-1" />}
                {crumb?.label}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;